import React from 'react';
import withLabelAndMeta from './withLabelandMeta';
import ScenarioPicker from '../ScenarioPicker';
import { SCENARIO_FIELDS } from '../../forms/scenarioCreate';

const ScenarioPickerForForm = ({
  setFieldValue,
  field, // { name, value, onChange, onBlur }
  fieldDefinition,
  lookupData: { scenarios },
  values,
}) => (
  <ScenarioPicker
    mt={1}
    id={fieldDefinition.key}
    active={field.value}
    scenarios={scenarios}
    onChange={(id) => {
      const picked = scenarios.find(scenario => scenario.id === id);
      if (
        values[SCENARIO_FIELDS.NAME] === ''
        && picked.name.value // active plan's string is in picked.name.
      ) {
        setFieldValue(SCENARIO_FIELDS.NAME, `${picked.name.value} - copy`);
      }

      setFieldValue(field.name, id);

      if (id !== 0) {
        setFieldValue(SCENARIO_FIELDS.DATERANGE, {
          start: picked.fromDate,
          end: picked.toDate,
        });
      } else {
        setFieldValue(SCENARIO_FIELDS.DATERANGE, {
          start: values.dateRange.start,
          end: values.dateRange.end,
        });
      }
    }}
  />
);

export default withLabelAndMeta(ScenarioPickerForForm);
